import merge from "@suid/utils/merge";
export const shapeDefaults = createShapeOptions({
    borderRadius: 4,
});
export function createShapeOptions(data) {
    return data;
}
export function createShape(options) {
    const result = {
        ...merge({}, shapeDefaults, options),
    };
    return result;
}
export default createShape;
